/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneyDocument = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 7h3v2h-3v2h1a3 3 0 1 1 0 6h-1v1h-2v-1H8v-2h3v-2h-1a3 3 0 1 1 0-6h1V6h2zm0 8h1a1 1 0 1 0 0-2h-1zm-3-6a1 1 0 0 0 0 2h1V9z" />
        <path d="M20 22H4V2h16zM6 20h12V4H6z" />
      </g>
    </g>
  </Icon>
);
export { SvgMoneyDocument as MoneyDocument };
